'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BASE_URL = 'https://75b9bx130e.execute-api.eu-west-1.amazonaws.com/production/scraper/facebook/thumbnail';

var iconStyle = {
  margin: '0 auto'
};

var failedIconWrapperStyle = {
  height: 50,
  display: 'flex',
  'align-items': 'center'
};

var DyzioFacebookThumbnail = function (_Component) {
  (0, _inherits3.default)(DyzioFacebookThumbnail, _Component);

  function DyzioFacebookThumbnail(props) {
    (0, _classCallCheck3.default)(this, DyzioFacebookThumbnail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DyzioFacebookThumbnail.__proto__ || (0, _getPrototypeOf2.default)(DyzioFacebookThumbnail)).call(this, props));

    _this.state = {
      loading: true,
      failed: false,
      url: null
    };
    return _this;
  }

  (0, _createClass3.default)(DyzioFacebookThumbnail, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var assetId, response, url, failed;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                assetId = this.props.assetId;
                _context.next = 3;
                return _axios2.default.get(BASE_URL + '/' + assetId);

              case 3:
                response = _context.sent;
                url = _lodash2.default.get(response, 'data.data.url', null);
                failed = _lodash2.default.has(response, 'data.errorType');

                this.setState({
                  loading: false,
                  url: url,
                  failed: failed
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          failed = _state.failed,
          url = _state.url,
          loading = _state.loading;
      var _props = this.props,
          assetId = _props.assetId,
          failedText = _props.failedText,
          rest = (0, _objectWithoutProperties3.default)(_props, ['assetId', 'failedText']);


      if (loading) {
        return null;
      }

      if (failed) {
        return _react2.default.createElement(
          'div',
          { style: failedIconWrapperStyle },
          _react2.default.createElement(_semanticUiReact.Popup, {
            content: failedText,
            trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'picture', size: 'big', style: iconStyle })
          })
        );
      }

      return _react2.default.createElement(_semanticUiReact.Image, (0, _extends3.default)({ 'data-fetched': 'dyzio-thumb-l', src: url }, rest));
    }
  }]);
  return DyzioFacebookThumbnail;
}(_react.Component);

DyzioFacebookThumbnail.propTypes = {
  assetId: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  failedText: _propTypes2.default.string
};

DyzioFacebookThumbnail.defaultProps = {
  failedText: 'Failed to load thumbnail. Try again later',
  style: {
    width: '100%',
    height: 50,
    'object-fit': 'cover'
  }
};

exports.default = DyzioFacebookThumbnail;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/dyzio-facebook-thumbnail/index.js
 ** module id = 2581
 ** module chunks = 0
 **/